import { motion } from "framer-motion";
import {
  HeroSectionContainer,
  HeroBoxing,
  HeroSectionDiv1,
  HeroSectionDiv1P,
  HeroSectionDiv2,
  HeroSectionDiv3,
  HeroSectionDiv3P,
  HeroSectionCard,
  HeroSectionCards,
  HeroSectionImage,
  HeroSectionTitle,
  HeroSectionContent,
} from "./HeroSection.styled";
import { service } from "../../constants";
import { useTranslation } from "react-i18next";
import { selectLocale } from "../../locales/localeSlice";
import { useSelector } from "react-redux";
import EntranceAnimationY from "../../components/EntranceAnimationY";

const HeroSection = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);

  return (
    <HeroSectionContainer>
      <HeroBoxing>
        <motion.div
          initial={{ y: "-50%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 2.5, delay: 4 }}
        >
          <HeroSectionDiv1>
            <HeroSectionDiv1P>
              {t("SERVICES", { lng: currentLocale })}
            </HeroSectionDiv1P>
          </HeroSectionDiv1>

          <HeroSectionDiv2>
            <h3>
              {t("Build the future of real-time payments with FiPay", {
                lng: currentLocale,
              })}
            </h3>
          </HeroSectionDiv2>
          <HeroSectionDiv3>
            <HeroSectionDiv3P>
              {t(
                "Providers can connect to a fast, simple, and secure pay with bank option",
                { lng: currentLocale }
              )}{" "}
              {t("", {
                lng: currentLocale,
              })}
              {t("", {
                lng: currentLocale,
              })}
            </HeroSectionDiv3P>
          </HeroSectionDiv3>
        </motion.div>
      </HeroBoxing>

      <EntranceAnimationY duration={2} delay={3.5}>
        <HeroSectionCard>
          {service.map((service) => (
            <HeroSectionCards key={service.title}>
              <HeroSectionImage src={service.img} alt="service" />
              <HeroSectionTitle>
                {t(service.title, { lng: currentLocale })}
              </HeroSectionTitle>
              <HeroSectionContent>
                {t(service.content, { lng: currentLocale })}
              </HeroSectionContent>
            </HeroSectionCards>
          ))}
        </HeroSectionCard>
      </EntranceAnimationY>
    </HeroSectionContainer>
  );
};

export default HeroSection;
